import axios from "axios";

const BASE_URL = process.env.REACT_APP_OSE_QUERY_SERVICE_URL;

const headers = {
  "Content-Type": "application/json",
};

export function oseQuery(formData) {
  return axios.post(BASE_URL, formData, { headers });
}
